
export enum ClientJuridicalNature {
    juridical = 'juridical',
    physical = 'physical'
}


